import React, { useEffect } from "react";
import "./BagCareSection.css";
import { FaApple, FaGooglePlay } from "react-icons/fa";
import RatingMaxima from "../Maxima/RatingMaxima/RatingMaxima";
// import WorntoWow from "./WorntoWow/WorntoWow";
import RatingShoeCare from "../ShoeCare/RatingShoeCare/RatingShoeCare";
import {
  Container,
  Row,
  Col,
  Navbar,
  Nav,
  Button,
  Card,
  Badge,
  ListGroup,
} from "react-bootstrap";

import EverydayTotes from "./EverydayTotes/EverydayTotes";
import WornWonder from "./WornWonder/WornWonder";
import BagCareService from "./BagCareService";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import ServiceAccordion from "../ServiceAccordion/ServiceAccordion";
const shosecare = "/BagCare-1.webp";
export default function BagCareSection() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);
  return (
    <div>
      <section className="hero-section-wash-fold mt-5">
        <div className="hero-overlay-wash-fold mt-5">
          <Container fluid="xl" className="py-5 mt-4 h-100">
            <Row className="align-items-center justify-content-center text-center h-100 mt-5">
              <Col lg={8}>
                <h1 className="hero-title mb-4">
                  Expert BagCare
                  <br />
                </h1>

                <span className="hero-highlight-wash-fold">
                  For the Pieces You Carry Every Day — and the Ones You Don't. A
                  bag is not just an accessory. In the right hands, it lasts a
                  lifetime. Whether it is your everyday tote, a structured work
                  bag, or a designer piece you reach for only on special
                  occasions, your bags accumulate more than you see. Transferred
                  dye from clothing, oil and moisture from handling, dust in the
                  lining, and environmental residue all quietly degrade the
                  material and hardware. Our Bag Care service addresses all of
                  it with specialist attention.
                </span>

                <br />
                <div className="d-flex justify-content-center flex-wrap gap-3 mt-4">
                  <button className="suhedule-btn-dark"  onClick={() =>
    window.open(
      "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
      "_blank"
    )
  }>
                    BOOk NOW
                  </button>

                  <button
                    className="view-prices-list"
                    onClick={() => navigate("/laundry-price")}
                  >
                    VIEW PRICE LIST
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      <BagCareService />
      <div data-aos="fade-up">
        <WornWonder />
      </div>

      <div data-aos="fade-up">
        <EverydayTotes />
      </div>

      <div data-aos="fade-up">
        <ServiceAccordion/>
      </div>
    

      <div></div>
    </div>
  );
}
